import { render, staticRenderFns } from "./CompaniesSelectionCard.vue?vue&type=template&id=1a84ccf7&scoped=true&"
import script from "./CompaniesSelectionCard.vue?vue&type=script&lang=js&"
export * from "./CompaniesSelectionCard.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesSelectionCard.vue?vue&type=style&index=0&id=1a84ccf7&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a84ccf7",
  null
  
)

export default component.exports